import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import LegalPersonList from "./LegalPersonList";
import LegalPersonCreate from "./LegalPersonCreate";
import LegalPersonEdit from "./LegalPersonEdit";
import LegalPersonDetailPage from "./LegalPersonDetailPage";
import { LegalPersonReportChange } from "./LegalPersonReportChange";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function LegalPersons() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.DISTRIBUTOR,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(LegalPersonList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(LegalPersonCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(LegalPersonEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/report-change/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(LegalPersonReportChange, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(LegalPersonDetailPage, null))); } })));
}
export default LegalPersons;
